import PropTypes from 'prop-types';

// eslint-disable-next-line no-unused-vars
const naNoObsOptions = [
  'N/A',
  'No Obs',
  'No Obs.',
  'NA',
  'Not obs.',
  'Not obs',
  'No aplica',
  'No Aplica',
  'NO OBS',
  'NO OBS.',
  'na',
  'n/a',
  'no aplica',
  'no aplica.',
];


export const calcScore = ({newValue, data, auditData}) => {
  const modifiedSection = data?.find((section) => section?._id === newValue?.section);
  const modifiedQuestion = modifiedSection?.questions?.find((question) => question?._id === newValue?.question);
  const optimalScore = Math.max(...(modifiedQuestion?.select?.options?.map(option => option.score) || 0));
  let questionTotalScore = modifiedSection?.totalScore;
  let questionFinalScore = modifiedSection?.finalScore;
  let auditTotalScore = auditData?.data?.totalScore;
  let auditFinalScore = auditData?.data?.finalScore;
  const prevSelectedOption = modifiedQuestion?.select?.options?.find((option) => option._id === modifiedQuestion?.answer?.templateAnswer?.select[0]);
  const currentSelectedOption = modifiedQuestion?.select?.options?.find((option) => option._id === newValue?.templateAnswer?.select[0]);

  if (prevSelectedOption?.score < currentSelectedOption?.score) {
    const dif = currentSelectedOption?.score - prevSelectedOption?.score;
    questionFinalScore += dif;
    auditFinalScore += dif;
    if (!prevSelectedOption?.score && prevSelectedOption?.score !== 0) {
      questionTotalScore += optimalScore;
      auditTotalScore += optimalScore;
    }
  }
  if (typeof (currentSelectedOption?.score) === 'number' && (prevSelectedOption?.score > currentSelectedOption?.score)) {
    const dif = prevSelectedOption?.score - currentSelectedOption?.score;
    questionFinalScore -= dif;
    auditFinalScore -= dif;
  }
  if (!prevSelectedOption?.score && currentSelectedOption?.score === 0) {
    questionTotalScore += optimalScore;
    auditTotalScore += optimalScore;
  }
  if (!currentSelectedOption?.score && prevSelectedOption?.score === 0) {
    questionTotalScore -= optimalScore;
    auditTotalScore -= optimalScore;
  }

  if (!currentSelectedOption?.score && currentSelectedOption?.score !== 0 && prevSelectedOption.score) {
    questionTotalScore -= optimalScore;
    auditTotalScore -= optimalScore;
    if (prevSelectedOption?.score !== 0) {
      questionFinalScore -= prevSelectedOption?.score;
      auditFinalScore -= prevSelectedOption?.score;
    }
  }
  return {questionTotalScore, questionFinalScore, auditFinalScore, auditTotalScore};
};

calcScore.propTypes = {
  data: PropTypes.object,
  newValue: PropTypes.object,
  auditData: PropTypes.object,
};
